var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[[_c('list-group',{attrs:{"title":'GPSウォーク／ランイベント'}},[_c('list-item',{attrs:{"spanText":'Q. ',"text":'参加中の複数のイベントを見る方法',"urlName":'Help36'}}),_vm._v(" "),_c('list-item',{attrs:{"spanText":'Q. ',"text":'参加中のイベントを退出したい',"urlName":'Help37'}})],1)]],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14daab7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HelpCategory21.vue
// module id = 0YkT
// module chunks = 0